import React, { useContext, useState, useRef, useEffect } from "react";
import { Divider, Drawer, IconButton, Paper, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AppContext from "../../Contexts/AppContext";
import { LayerSettingsComponent } from "../../../schemes/layers/LayerSettings/LayerSettingsComponent/LayerSettingsComponent";
import { useTranslation } from "react-i18next";
import { ProductsList } from "../../CustomComponents/ProductsList/ProductsList";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import DOMPurify from "dompurify"; // Importamos DOMPurify

import InfoIcon from "@mui/icons-material/Info";
import "./Sidebar.scss";
import { motion, AnimatePresence } from "framer-motion";
import { Item } from "../../CustomComponents/Item/Item";
import DownloadIcon from "@mui/icons-material/Download";
import { downloadAllAttachments } from "../../../api/ApiAttachments";
import AsbestosLayerGroup from "../../../schemes/layer_groups/asbestos/AsbestosLayerGroup";
import AsbestosDashboardLayerGroup from "../../../schemes/layer_groups/asbestos/AsbestosDashboardLayerGroup";
import { AsbestosInventoryLayer } from "../../../schemes/layers/Asbestos/AsbestosInventoryLayer";
import { toast } from "react-toastify";

export default function Sidebar() {
  const { t, i18n } = useTranslation("main");
  const {
    project,
    openDrawer,
    setOpenDrawer,
    drawerWidth,
    setDrawerWidth,
    myProjectsRef,
    // sidebarRef,
    isWindowLayerDashboardOpen,
    isSelectingProject,
    setIsSelectingProject,
    layersGroups,
  } = useContext(AppContext);

  const isResizing = useRef(false);
  const isMobile = window.innerWidth < 960;
  const isRotated = window.innerWidth > window.innerHeight;
  // const [isSelectingProject, setIsSelectingProject] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  useEffect(() => {
    setIsSelectingProject(false);
  }, [openDrawer]);

  useEffect(() => {
    if (isSelectingProject) {
      const selectProjectWidth = 900;
      if (drawerWidth < selectProjectWidth) setDrawerWidth(selectProjectWidth);
    } else {
      const selectProjectWidth = 450;
      if (drawerWidth > selectProjectWidth) setDrawerWidth(selectProjectWidth);
    }
  }, [isSelectingProject]);

  useEffect(() => {
    if (!isWindowLayerDashboardOpen) return;
    const dashboardWidth = 900;
    setDrawerWidth(dashboardWidth);
  }, [isWindowLayerDashboardOpen]);

  // Inicia el redimensionamiento
  const startResizing = (event) => {
    isResizing.current = true;
    document.addEventListener("mousemove", resizeDrawer);
    document.addEventListener("mouseup", stopResizing);
  };

  // Ajusta el ancho en tiempo real mientras el usuario arrastra
  const resizeDrawer = (event) => {
    if (isResizing.current) {
      let newWidth = event.clientX; // El borde derecho sigue la posición del mouse
      if (newWidth < 300) newWidth = 300; // Ancho mínimo
      if (newWidth > window.innerWidth * 0.8)
        newWidth = window.innerWidth * 0.8; // Máximo 80% de la pantalla
      setDrawerWidth(newWidth);
    }
  };

  // Detiene el redimensionamiento
  const stopResizing = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", resizeDrawer);
    document.removeEventListener("mouseup", stopResizing);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const toggleIsSelectingProject = () => {
    setIsSelectingProject(!isSelectingProject);
  };

  const onSelectProject = () => {
    setIsSelectingProject(!isSelectingProject);
    // handleDrawerClose();
  };

  const handleDownloadAllAttachments = async () => {
    const asbestosLayerGroup = layersGroups?.find(
      (group) =>
        Object.getPrototypeOf(group) === AsbestosDashboardLayerGroup.prototype
    );
    const inventoryLayer = asbestosLayerGroup?.layers?.find(
      (layer) =>
        Object.getPrototypeOf(layer) === AsbestosInventoryLayer.prototype
    );

    if (!inventoryLayer?.uuid) {
      console.warn("No inventory layer found or missing uuid");
      return;
    }

    const toast_id = toast.loading(
      `${t("downloading_all_attached_files")}...`,
      {
        position: "top-right",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      }
    );

    try {
      await downloadAllAttachments(inventoryLayer?.uuid, project);

      toast.update(toast_id, {
        render: t("all_attached_files_downloaded_successfully"),
        type: "success",
        isLoading: false,
        autoClose: 5000,
      });
    } catch (error) {
      toast.update(toast_id, {
        render: t("download_all_attachments_error"),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  return (
    <Drawer
      anchor="left"
      open={openDrawer}
      onClose={handleDrawerClose}
      variant="persistent"
      PaperProps={{
        style: {
          width: `${drawerWidth}px`,
          overflow: "visible",
          display: "flex",
          flexDirection: "row",
          transition: isResizing.current ? "" : "width 0.3s ease-in-out",
        },
      }}
    >
      <div className="drawer-container">
        <IconButton
          onClick={handleDrawerClose}
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: "99",
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* {isSelectingProject ? ( */}
        <div
          style={{ overflow: isMobile && isRotated ? "auto" : "" }}
          className={`slide-content ${isSelectingProject ? "show-first" : "show-second"}`}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  padding: "1rem",
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                  // flexDirection: "column",
                }}
              >
                <h3
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    // cursor: "pointer",
                    // marginBottom: "0.5rem",
                  }}
                >
                  {t("select_project")}
                </h3>
              </div>
              <Divider />
            </div>
            <ProductsList onSelectProject={onSelectProject} />
          </div>
          {/* ) : ( */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                // alignItems: "center",
              }}
            >
              <div
                ref={myProjectsRef}
                style={{
                  padding: "1rem",
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                  // flexDirection: "column",
                  cursor: "pointer",
                }}
                onClick={toggleIsSelectingProject}
              >
                {/* <IconButton onClick={toggleIsSelectingProject}> */}
                <ArrowBackIosNewIcon style={{ color: "black" }} />
                {/* </IconButton> */}
                <h3
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    // marginBottom: "0.5rem",
                  }}
                >
                  {t("click_to_select_a_project")}
                </h3>
              </div>
              <Divider />
            </div>
            <div
              style={{
                display: "flex",
                // flexDirection: "column",
                alignItems: "center",
              }}
            >
              <h2
                style={{
                  padding: "1rem",
                  margin: 0,
                  // cursor: "pointer",
                  color: "black",
                  textAlign: "center",
                  flexGrow: "1",
                }}
              >
                {project?.title?.[i18n.language]}
              </h2>
              <div>
                {project?.category === "AMIANTO" && (
                  <Tooltip title={t("download_all_attachments")}>
                    <IconButton
                      style={{
                        height: "fit-content",
                        position: "relative",
                      }}
                      onClick={handleDownloadAllAttachments}
                    >
                      <DownloadIcon />
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title={t("show_info")}>
                  <IconButton
                    style={{
                      height: "fit-content",
                      position: "relative",
                    }}
                    onClick={() => setShowInfo(true)}
                  >
                    <InfoIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {showInfo && (
                <Item item={project} onClose={() => setShowInfo(false)} />
              )}
            </div>

            <h5
              style={{
                padding: "1rem",
                margin: 0,
                // cursor: "pointer",
                color: "black",
                textAlign: "center",
              }}
            >
              {project?.description_short?.[i18n.language]}
            </h5>

            <LayerSettingsComponent openDrawer={openDrawer} />
          </div>
        </div>
      </div>

      {/* Handle de redimensionamiento */}
      <div
        style={{
          width: "8px",
          height: "100%",
          backgroundColor: "#ccc",
          // position: "absolute",
          // top: 0,
          // right: 0,
          cursor: "ew-resize",
          // position: "relative",
        }}
        onMouseDown={startResizing}
      >
        {/* <img
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-25%, -50%)",
            backgroundColor: "white",
            border: "1px solid lightgrey",
            borderRadius: "4px",
            width: "16px",
            height: "20px",
            padding: "2px",
            pointerEvents: "none",
            userSelect: "none", // Evita que la imagen sea seleccionada
          }}
          src="images/icons/drag-and-drop-dots-six-dots-icon.svg"
        /> */}
      </div>
    </Drawer>
  );
}
